export default {
  
  en: {
    settleTime: 'Due date',
    title: 'Collection Management',
    allTitle: 'All Collection Tasks',
    mytitle: 'My Collection Tasks',
    historytitle: 'History Collection Tasks',
    performancetitle: 'Collection Performance',

    createTime: 'Created on',
    followNum: 'Follow number',
    followUserName: 'follower',
    followResult: 'FollowResult',
    followTime: 'Follow Time',
    repaymentIntention: 'Repayment Intention',
    collectionTaskStatus: 'Task Statusa',
    batchReplacementFollowStaff: 'Batch Replacement Follow Staff',
    transferOrder: 'Transfer Order',
    userName: 'User Name',
    collectionNumber: 'Collection Number',
    collectionAmount: 'Collection Amount',
    pendingNum: 'Pending number',
    processNum: 'Process number',
    cancelNum: 'Cancel number',
    succedNumber: 'Succed Number',
    extendNumber: 'Extend Number',
    succedAmount: 'Succed Amount',
    succedRate: 'Succed Rate',
    approval: 'Approval',
    endTime: 'Due date',
    applyReductionAmt: 'apply reduction amount',
    balFee: 'balance late fee',
    countResult: 'Count Result',
    countResultRate: 'Count Result Rate',
    userId: 'user id',
    groupName: 'group name',
    linkCondition: 'Contact Information Base',
    custContractCondition: 'Customer contact information',
    amountSuccedRate: 'Amount Succed Rate',
    amountPaidRate: 'Amount Paid Rate',
    ym: 'ym',
    ifAmtRate: 'Amount rate',
    ifAmtFirstOverdueRate: 'Amount first overdue rate',
    ifAmtUnSettleRate: 'Amount unsettle rate',
    ifAmtEarlySettledRate: 'Amount early settled rate',
    ifAmtOverdueSettledRate: 'Amount overdue settled rate',
    ifAmtExtendsionSettledRate: 'Amount extendsion settled rate',
    ifAmtOverdueExtendsionSettledRate: 'Amount overdue extendsion settled rate',
    ifAmtSettledRate: 'Amount settled rate',
    ifLoanCount: 'Loan count',
    operationTime: 'operation Time',
    operationUserName: 'operation User Name',
    operationUserMobile: 'operation User Mobile',
    operationType: 'operationType',
    taskIdOld: 'taskId Old',
    taskIdNew: 'taskId New',
    orderInfoId: 'Order info id',
    custInfoId: 'Customer info id',
    waitingForCollection: 'Waiting For Collection',
    answeredByThemSelf: 'answered by them self',
    notInPerson: 'Not in person',
    noAnswer: 'no answer',
    emptyNumber: 'empty number',
    turnedOff: 'turned off',
    unavailable: 'unavailable',
    whatsappPromisesToPayBackOnTime: 'Whatsapp promises to pay back on time',
    WhatsappDidNotReply: 'Whatsapp did not reply',
    NoTieneCuentaDeWhatsapp: 'No tiene cuenta de whatsapp',
    haveAWishAndCanReturnTheLoan: 'have a wish and can return the loan',
    haveAWishButCantReturnTheLoan: `have a wish but can't return the loan`,
    canReturnTheLoanButRefuseToPayIt: 'can return the loan but refuse to pay it',
    canReturnTheLoanButWantToConsult: 'can return the loan but want to consult',
    cantJudgeItForNow: `can't judge it for now`,
    LaPersonaDeContactoPuedeComunicarleAlClienteParaElReembolso: 'The contact person can notify the customer of a refund ',
    ElContactoNoPuedeComunicarse: 'Contact person unable to communicate ',
    LaInformaciónDelContactoEsFalsa: 'The contact information is incorrect ',
    createdTime: 'Create Time',
    id: 'ID',
    remark: 'description',
    sysMobile: 'CollectionAccount',
    attendanceCount: 'Number of working days'
  },
  es: {
    title: 'Trung tâm thu hồi nợ',
    allTitle: 'Quản lý nhiệm vụ thu hồi nợ',
    mytitle: 'Nhiệm vụ thu hồi nợ của tôi',
    historytitle: 'Lịch sử nhiệm vụ thu hồi nợ',
    performancetitle: 'Hiệu suất thu hồi nợ',
    createTime: 'Thời gian chuyển vào thu hồi',
    followNum: 'Số lần theo dõi',
    followUserName: 'Người theo dõi',
    followResult: 'Kết quả theo dõi',
    followTime: 'Thời gian theo dõi',
    repaymentIntention: 'Mức độ thiện chí trả nợ',
    collectionTaskStatus: 'Trạng thái nhiệm vụ thu hồi',
    batchReplacementFollowStaff: 'Thay đổi nhân viên theo dõi hàng loạt',
    transferOrder: 'Điều đơn',
    userName: 'Nhân viên thu hồi',
    mobile: 'Số điện thoại',
    collectionNumber: 'Tổng số phân đơn',
    collectionAmount: 'Tổng số tiền được phân',
    pendingNum: 'Tổng đơn chờ xử lý',
    processNum: 'Tổng đơn đang theo dõi',
    cancelNum: 'Tổng đơn hủy',
    succedNumber: 'Tổng đơn thu hồi',
    extendNumber: 'Số đơn gia hạn',
    succedAmount: 'Số tiền thu hồi (hợp đồng)',
    amountPaidAmt: 'Số tiền thu hồi (thực tế)',
    succedRate: 'Tỷ lệ thu hồi (theo đơn)',
    paymentamt: 'Số tiền thu hồi',
    naNum: 'Số khách hàng tự nguyện trả nợ',
    approval: 'Phê duyệt',
    endTime: 'Ngày hết hạn',
    settleTime: 'Thời gian kết thúc thu hồi',
    firstOverdueCount: 'Tổng số thu hồi 1-3 ngày',
    firstOverdueAmt: 'Số tiền thu hồi 1-3 ngày',
    secOverdueCount: 'Tổng số thu hồi 4-7 ngày',
    secOverdueAmt: 'Số tiền thu hồi 4-7 ngày',
    thridOverdueCount: 'Tổng số thu hồi trên 8 ngày',
    thridOverdueAmt: 'Số tiền thu hồi trên 8 ngày',
    applyReductionAmt: 'Số tiền xin giảm miễn',
    balFee: 'Phí quá hạn còn lại',
    countResult: 'Kết quả thống kê',
    countResultRate: 'Tỷ lệ kết quả thống kê',
    userId: 'Mã nhân viên thu hồi',
    groupName: 'Nhóm thu hồi',
    linkCondition: 'Tình trạng danh bạ và người liên hệ',
    custContractCondition: 'Tình trạng liên hệ chính chủ',
    amountSuccedRate: 'Tỷ lệ thu hồi (theo hợp đồng)',
    amountPaidRate: 'Tỷ lệ thu hồi (theo tiền đã trả)',
    ym: 'Ngày',
    ifAmtRate: 'Tỷ lệ',
    ifAmtFirstOverdueRate: 'Tỷ lệ quá hạn lần đầu',
    ifAmtUnSettleRate: 'Tỷ lệ nợ xấu',
    ifAmtEarlySettledRate: 'Tỷ lệ tất toán trước hạn',
    ifAmtOverdueSettledRate: 'Tỷ lệ tất toán quá hạn',
    ifAmtExtendsionSettledRate: 'Tỷ lệ tất toán gia hạn',
    ifAmtOverdueExtendsionSettledRate: 'Tỷ lệ tất toán gia hạn quá hạn',
    ifAmtSettledRate: 'Tỷ lệ tất toán bình thường',
    ifLoanCount: 'Loại khoản vay',
    operationTime: 'Thời gian thao tác',
    operationUserName: 'Tên người thao tác',
    operationUserMobile: 'Tài khoản người thao tác',
    operationType: 'Loại thao tác',
    taskIdOld: 'Mã nhiệm vụ cũ',
    taskIdNew: 'Mã nhiệm vụ mới',
    orderInfoId: 'Mã đơn hàng',
    custInfoId: 'Mã khách hàng',
    waitingForCollection: 'Chờ theo dõi',
    answeredByThemSelf: 'Chính chủ nghe máy',
    notInPerson: 'Không phải chính chủ nghe máy',
    noAnswer: 'Không ai nghe máy',
    emptyNumber: 'Số trống',
    turnedOff: 'Tắt máy',
    unavailable: 'Ngừng hoạt động',
    whatsappPromisesToPayBackOnTime: 'Whatsapp cam kết trả nợ đúng hạn',
    WhatsappDidNotReply: 'Whatsapp không phản hồi',
    NoTieneCuentaDeWhatsapp: 'Không có tài khoản Whatsapp',
    haveAWishAndCanReturnTheLoan: 'Có ý muốn và có khả năng trả nợ',
    haveAWishButCantReturnTheLoan: `Có ý muốn trả nợ nhưng không có khả năng`,
    canReturnTheLoanButRefuseToPayIt: 'Có khả năng nhưng từ chối trả nợ',
    canReturnTheLoanButWantToConsult: 'Có khả năng nhưng cần thương lượng',
    cantJudgeItForNow: `Tạm thời chưa thể xác định`,
    LaPersonaDeContactoPuedeComunicarleAlClienteParaElReembolso: 'Người liên hệ có thể thông báo khách hàng trả nợ',
    ElContactoNoPuedeComunicarse: 'Người liên hệ không thể giao tiếp',
    LaInformaciónDelContactoEsFalsa: 'Thông tin người liên hệ trong danh bạ là giả',
    createdTime: 'Thời gian tạo',
    id: 'ID',
    remark: 'Mô tả',
    sysMobile: 'Tài khoản nhân viên thu hồi',
    attendanceCount: 'Số ngày làm việc'
  },
}
